import React from 'react';
import ReactDOMClient from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';

import App from './App';
import { store } from '../redux';
import UTMMiddleware from '../middlewares/utm-middleware';

import 'src/firebase-client';

const Wrap = (
  <HelmetProvider>
    <Provider store={store}>
      <Router>
        <UTMMiddleware>
          <App />
        </UTMMiddleware>
      </Router>
    </Provider>
  </HelmetProvider>
);

const container = document.getElementById('root');
if (container) ReactDOMClient.hydrateRoot(container, Wrap);
